import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Home } from '@/features/home'

const homeSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/')({
  validateSearch: homeSearchSchema,
  beforeLoad: () => {
    // Redirect to default tab
    throw redirect({
      to: '/generic/users',
      search: { language: 'en' },
    })
  },
  component: Home,
})
